var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTarjetas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-tarjetas",
    transform: "translate(-0.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1883",
    "data-name": "Rect\\xE1ngulo 1883",
    transform: "translate(0.333)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 40,
    height: 39,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "credit-card-svgrepo-com",
    d: "M3,12.035H35.715M10.27,22.588h3.635M8.816,29.623H29.9c2.036,0,3.054,0,3.831-.383A3.578,3.578,0,0,0,35.319,27.7c.4-.752.4-1.738.4-3.708V10.628c0-1.97,0-2.955-.4-3.708A3.578,3.578,0,0,0,33.73,5.383C32.953,5,31.935,5,29.9,5H8.816C6.78,5,5.762,5,4.985,5.383A3.578,3.578,0,0,0,3.4,6.921C3,7.673,3,8.658,3,10.628V24c0,1.97,0,2.955.4,3.708A3.578,3.578,0,0,0,4.985,29.24C5.762,29.623,6.78,29.623,8.816,29.623Z",
    transform: "translate(1.522 3.524)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTarjetas);
export default __webpack_public_path__ + "static/media/icon-tarjetas.5bc54be4135946b209523a501356773c.svg";
export { ForwardRef as ReactComponent };